import styled from "styled-components"

export const SliderContainer = styled.div `
    width: 100%;
    height: 788px;
    min-height: 788px;
    display: block;
    position: relative;
`